import { Icon } from '@iconify/react';
import { IconButton } from '@mui/material';
import plusUp from '@iconify/icons-eva/plus-fill';
import EmptyCell from 'components/EmptyCell';
import React from 'react';
import { validationWorkoutId } from 'utils/validationRoutineRow';
import { WorkoutPlusWrapper } from './style';

interface IProps {
  row: IChallengeRoutines;
}

export function WorkoutFormatterComponent({ row }: IProps) {
  if (
    row.name === 'isRest'
    //  || row.alt_workouts_part
  ) {
    return <EmptyCell />;
  }

  return (
    <div
      style={{
        position: 'relative',
        height: '100%',
        margin: '0px -8px',
        border: validationWorkoutId(row) ? 'none' : '2px solid #FF4842',
      }}
    >
      <span>{row.name}</span>
      {/* {row.name && (
        <WorkoutPlusWrapper>
          <IconButton
            size='small'
            sx={{ mr: 1 }}
            onClick={onClickAdd}
            // disabled={isLastRow}
          >
            <Icon icon={plusUp} color='#a8a8a8' />
          </IconButton>
        </WorkoutPlusWrapper>
      )} */}
    </div>
  );
}
